import { RequestService } from '../request-service';
import type {
  ConductRequest,
  ConductResponse,
} from '@wix/ambassador-featuretoggle-server-v1-feature-toggle/types';
import type RpcModule from '@wix/ambassador-featuretoggle-server-v1-feature-toggle/rpc';
import type HttpModule from '@wix/ambassador-featuretoggle-server-v1-feature-toggle/http';

type conduct = {
  featureToggleId: string;
};

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class FeatureToggleService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-featuretoggle-server-v1-feature-toggle/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import(
      '@wix/ambassador-featuretoggle-server-v1-feature-toggle/http'
    );
  }

  public async conduct(payload: conduct): Promise<boolean> {
    try {
      const response = await this.request<ConductRequest, ConductResponse>({
        methodName: 'conduct',
        payload,
      });
      return response.featureToggleResult?.toggle ?? false;
    } catch {
      return false;
    }
  }
}
